// extracted by mini-css-extract-plugin
export default {"root":"Socials_root__9IKhZ","large":"Socials_large__b0NPJ","social":"Socials_social__+BXfB","topBar":"Socials_topBar__TeFV1"};